<template>
  <section id="root"
           role="main">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'TheMain'
};
</script>
